import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useAuthStore } from 'src/entities/user/store/useAuthStore';
import apiService from 'src/shared/config/apiService';
import handleAxiosError from 'src/shared/utils/handleAxiosError';

interface PostQuestionPayload {
  productId: string;
  stageId: string;
  questionId: number;
  answer: string | string[];
  withFiles?: boolean;
}

const postQuestion = async (payload: PostQuestionPayload): Promise<any> => {
  try {
    const { productId, stageId, questionId, answer } = payload;

    const { data } = await apiService.patch<any>(
      `/products/${productId}/${stageId}/questions/${questionId}`,
      { answer }
    );

    return data;
  } catch (error) {
    throw handleAxiosError(error);
  }
};

export const useSendQuestion = () => {
  const queryClient = useQueryClient();
  const id = useAuthStore((state) => state.user?.id);

  return useMutation({
    mutationFn: async (payload: PostQuestionPayload) => {
      return await postQuestion(payload);
    },
    onSuccess: async (_data, variables) => {
      if (!variables.withFiles) {
        queryClient.invalidateQueries({
          queryKey: ['product-updates', id, variables.productId]
        });
      }
    }
  });
};
